import { render, staticRenderFns } from "./listv2.vue?vue&type=template&id=bb1c5f3a&scoped=true&"
import script from "./listv2.vue?vue&type=script&lang=js&"
export * from "./listv2.vue?vue&type=script&lang=js&"
import style0 from "./listv2.vue?vue&type=style&index=0&id=bb1c5f3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c5f3a",
  null
  
)

export default component.exports